import React from "react";
import HomeTestimonials from "../../beranda/Testimonials";

const TestimonialsProduct2 = () => {
  return <HomeTestimonials />;
};

export default TestimonialsProduct2;
